import * as requestFromServer from "./UserActionsCrud";
import { userActionSlice, callTypes } from "./UserActionsSlice";

const {actions} = userActionSlice;

export const getUserGroups = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getUserGroups()
    .then(response => {
      dispatch(actions.userGroupsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getPersonnelUsers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getPersonnelUsers(queryParams)
    .then(response => {
      dispatch(actions.usersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllPersonnelUsers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllPersonnelUsers(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getTeacherUsers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getTeacherUsers(queryParams)
    .then(response => {
      dispatch(actions.usersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllTeacherUsers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllTeacherUsers(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getStudentUsers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getStudentUsers(queryParams)
    .then(response => {
      dispatch(actions.usersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllStudentUsers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllStudentUsers(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getParentUsers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getParentUsers(queryParams)
    .then(response => {
      dispatch(actions.usersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllParentUsers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllParentUsers(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getPersonnelTypes = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getPersonnelTypes()
    .then(response => {
      dispatch(actions.filtersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getBranches = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getBranches()
    .then(response => {
      dispatch(actions.filtersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getSections = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getSections()
    .then(response => {
      dispatch(actions.filtersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getIPList = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getIPList(id)
    .then(response => {
      dispatch(actions.IPListFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getUsername = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getUsername()
    .then(response => {
      dispatch(actions.usernameFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveIPList = (ids, data) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveIPList(ids, data)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const updateUsernameAndPassword = usernameAndPassword => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateUsernameAndPassword(usernameAndPassword)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const toggleActiveness = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .toggleActiveness(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanIPList = () => dispatch => {
  dispatch(actions.IPListCleaned());
};

export const cleanUsername = () => dispatch => {
  dispatch(actions.usernameCleaned());
};

export const cleanUserActionsState = () => dispatch => {
  dispatch(actions.userActionsStateCleaned());
};